module.exports = __webpack_public_path__ + "fonts/UniversalSans-600.bb4e3de.otf";